/* eslint-disable no-console */
import { put, call, all } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import {
  FeatureFlagType,
  getFeatureFlagSuccess,
} from '../../../reducers/featureFlagSlice';
import { api } from '../../../api/featureFlags/featureFlagsApi';
import withLoading from '../../../sagas/loadingSaga';

export default function* featureFlagSaga(
  action: PayloadAction<{
    flagNames: string[];
    currentUser: string | undefined;
  }>,
) {
  const flagNames = action.payload.flagNames;
  const currentUser = action.payload.currentUser;

  yield call(withLoading, function* () {
    yield all(
      flagNames.map((flagName) => call(getFeatureFlag, flagName, currentUser)),
    );
  });
}

function* getFeatureFlag(flagName: string, currentUser: string | undefined) {
  const featureFlagData: AxiosResponse<FeatureFlagType> = yield call(
    api.getFeatureFlagDetails,
    flagName,
    currentUser,
  );
  yield put(getFeatureFlagSuccess(featureFlagData.data));
}
